var model = BD.Model.extend({
    name: BD.attr('string')
})

module.exports = model
